export default "__VITE_ASSET__ByN$VNIx__"